'use client'

import { formatError } from './formatError'
import { InfoLogMeta, ErrorLogMeta } from './types'

export const logger = {
  info: (message: string, meta?: InfoLogMeta) => {
    console.info('[INFO]', message, meta || '')
    window?.newrelic?.recordCustomEvent('Info', { message, ...meta })
  },
  warn: (message: string, meta?: InfoLogMeta) => {
    console.warn('[WARN]', message, meta || '')
    window?.newrelic?.recordCustomEvent('Warning', { message, ...meta })
  },
  error: (error: unknown, meta?: ErrorLogMeta) => {
    const formattedError = formatError(error)

    if (meta) {
      console.error('[ERROR]', formattedError, meta)
    } else {
      console.error('[ERROR]', formattedError)
    }

    window?.newrelic?.noticeError(formattedError, meta)
  },
}
